import { isAddress } from "@bracket/chainography";
import type { UserAgreementType, VaultIdentifier, } from "@bracket/types";


export const USER_DATA = (address: string) => {

	if(!isAddress(address as string))
		throw new Error("wallet::USER_DATA - missing address");

	return `
		{
			wallet(address: "${address}") {
				created
				referee
				referee_id
				safary_id
				claimr_id
				claimr_rank
				claimr_points
				user {
					email
					company
					kyc_status
					kyc_since
					kyc_next_level
					kyc_rejected_level
					kyc_reason
					kyb_status
					kyb_reason
					kyb_level
					kyb_next_level
					kyb_rejected_level
					kyb_since
					agreements {
						agreement
						vaultAddress
						state
						created
					}
				}
			}
		}
`;
};


export const AGREE = ( agreement: UserAgreementType, vault?: VaultIdentifier, ) => {
	return vault ? `mutation { agree(agreement: ${agreement}, vault: "${vault}") }` : `mutation { agree(agreement: ${agreement}) }`;
};
